import InfoField from '../InfoField';
import { formatFecha } from '../../utils';

const PresupuestoOrigenBasics = ({
    origen,
    fechaLabel = 'Fecha',
    clienteDisplay = 'stack',
}) => (
    <>
        <div className="col-md-4">
            <InfoField label="Nº Presupuesto" value={origen?.numero || '-'} />
        </div>
        <div className="col-md-4">
            <InfoField
                label={fechaLabel}
                value={formatFecha(origen?.fecha)}
            />
        </div>
        <div className="col-md-4">
            <InfoField
                label="Cliente"
                className={
                    clienteDisplay === 'stack'
                        ? 'd-flex flex-column gap-1'
                        : undefined
                }
                value={
                    clienteDisplay === 'nameOnly' ? (
                        origen?.entidad?.nombre || '-'
                    ) : (
                        <>
                            <span>{origen?.entidad?.nombre || '-'}</span>
                            <span>{origen?.entidad?.telefono || ''}</span>
                        </>
                    )
                }
            />
        </div>
    </>
);

export default PresupuestoOrigenBasics;
